import { resolveBuilderPageSlug } from "./urlUtils"

/** True when the builder page is the default or slug-based Reviews page. */
export const isReviewsBuilderPage = (page, practice = null) => {
  if (page?.defaultPageType === "reviews" || page?.default_page_type === "reviews") return true

  const reviewsSlug = practice ? resolveBuilderPageSlug(practice, "reviews", "review") : null
  if (reviewsSlug && page?.slug === reviewsSlug) return true

  return page?.slug === "review" || page?.slug === "reviews"
}

/** True when rendering in the reviews page context (by defaultPageType or slug fallback). */
export const isReviewsPageType = (defaultPageType = null, pageSlug = null, practice = null) => {
  if (defaultPageType === "reviews") return true
  if (defaultPageType !== null) return false

  const reviewsSlug = practice ? resolveBuilderPageSlug(practice, "reviews", "review") : null
  if (reviewsSlug && pageSlug === reviewsSlug) return true

  return pageSlug === "review" || pageSlug === "reviews"
}

/** True when on the builder home page (defaultPageType or resolved home slug). */
export const isHomeBuilderPageType = (defaultPageType = null, pageSlug = null, practice = null) => {
  if (defaultPageType === "home") return true
  if (defaultPageType !== null) return false

  const homeSlug = practice ? resolveBuilderPageSlug(practice, "home", "home") : null
  if (homeSlug && pageSlug === homeSlug) return true

  return pageSlug === "home"
}

/** True when on a page that matches the packages listing slug (custom slug or legacy "packages"). */
export const isPackagesBuilderPageType = (pageSlug = null, practice = null, legacySlug = "packages") => {
  if (!pageSlug) return false

  const packagesSlug = practice ? resolveBuilderPageSlug(practice, null, legacySlug) : legacySlug
  return pageSlug === packagesSlug
}

/** Whether the reviews section header (title, rating, CTA) should display. */
export const getReviewsSectionShowHeader = (
  settings = {},
  defaultPageType = null,
  pageSlug = null,
  practice = null
) => {
  if (settings.showSectionHeader !== undefined) {
    return settings.showSectionHeader
  }

  return !isReviewsPageType(defaultPageType, pageSlug, practice)
}
